module.exports = __webpack_public_path__ + "img/scapp_2@2x.68ba7f62.png";